<template>
    <button v-if="isOpen" @click="toggleMobileNav(false)" class="navbar-toggler d-lg-none p-3"  type="button">
        <template v-if="darkHeaderActive">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 38 38"><g><g><path fill="none" stroke="#BAC4CC" stroke-miterlimit="20" stroke-width="3" d="M1.107 1.388l35.409 35.409"/></g><g><path fill="none" stroke="#BAC4CC" stroke-miterlimit="20" stroke-width="3" d="M1.107 36.796L36.516 1.387"/></g></g></svg>
        </template>
        <template v-else>
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 38 38"><g><g><path fill="none" stroke="#3a4c53" stroke-miterlimit="20" stroke-width="3" d="M1.107 1.388l35.409 35.409"/></g><g><path fill="none" stroke="#3a4c53" stroke-miterlimit="20" stroke-width="3" d="M1.107 36.796L36.516 1.387"/></g></g></svg>
        </template>
    </button>
    <button v-else @click="toggleMobileNav(true)" class="navbar-toggler d-lg-none p-3" :class="{'navbar-toggler--dark': darkHeaderActive }" type="button">
        &#9776;
    </button>
</template>

<script>
    export default{
        props: {
            darkHeaderActive: Boolean,
        },

        data(){
            return{
                isOpen: false
            }
        },

        methods: {
          toggleMobileNav(open){
              if(open){
                  document.querySelector(".mobile-navigation").classList.add("open");
                  document.querySelector("body").classList.add("menu-is-visible");
                  this.isOpen = true
              }

              else{
                  document.querySelector(".mobile-navigation").classList.remove("open");
                  document.querySelector("body").classList.remove("menu-is-visible");
                  this.isOpen = false
              }
            }
        }
    }

</script>
